// @flow
import { type Event, getEventCategoryApprovals } from './config';

const adminApproveProductClick = (): Event => ({
  category: getEventCategoryApprovals(),
  action: 'Click',
  label: 'Approve',
});

const adminApproveProductConfirmationClick = (): Event => ({
  category: getEventCategoryApprovals(),
  action: 'Submit',
  label: 'Approve',
});

const adminDeclineProductClick = (): Event => ({
  category: getEventCategoryApprovals(),
  action: 'Click',
  label: 'Decline',
});

const adminDeclineProductConfirmationClick = (hasReason: boolean): Event => ({
  category: getEventCategoryApprovals(),
  action: 'Submit',
  label: hasReason ? 'Decline with text' : 'Decline without text',
});

const adminEditAndApproveProductClick = (): Event => ({
  category: getEventCategoryApprovals(),
  action: 'Click',
  label: 'Edit',
});

const productEditedAndApproved = () => ({
  category: getEventCategoryApprovals(),
  action: 'Toast',
  label: `Edited and Approved`,
});

export default {
  adminApproveProductClick,
  adminApproveProductConfirmationClick,
  adminDeclineProductClick,
  adminDeclineProductConfirmationClick,
  adminEditAndApproveProductClick,
  productEditedAndApproved,
};
